import React, { Component } from "react";

import homepage_title from "./res/homepage/homepage_title.png";
import homepage_logo from "./res/homepage/homepage_logo.png";
import dl_android_icon from "./res/homepage/ico_android.png";
import dl_apple_icon from "./res/homepage/ico_ios.png";
import wechat_open_web from "./res/homepage/wechat_open_web.png";
import { FormattedMessage, injectIntl } from 'react-intl'
import Locale from './lang/Locale'

// https://www.npmjs.com/package/react-scroll-paged-view

const yyBaoLink = "https://a.app.qq.com/o/simple.jsp?pkgname=com.xdiarys.www"

class HomePage extends Component {

    constructor(props) {
        super(props);

        this.state = {
            iOSWeb: false,
            iOSUrl: '',
            isWechatWeb: 'none'
        };

        this.onClickDownload = this.onClickDownload.bind(this);
        this.isWeiXin = this.isWeiXin.bind(this);

        const lang = navigator.language;
    }

    componentDidMount() {

        var u = navigator.userAgent;
        //var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1;
        var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
        var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        this.setState({ iOSWeb: isiOS });



        let locale = Locale.Instance.getLocal();
        if (locale === 'zh') {
            if (isAndroid) {
                window.location = yyBaoLink;
            }
        }
        

        if( this.isWeiXin() && isAndroid ) {
            window.location = yyBaoLink;
        }


        let lang = Locale.Instance.getLang();

        let country = 'us';
        if( lang === 'chs' ) {
            country = 'cn';
        } else if( lang === 'cht' ) {
            country = 'tw';
        } else if( lang === 'kor' ) {
            country = 'kr';
        }


        document.title = Locale.Instance.getMessagebyId('homepage_title');

        let iOSUrl = `https://apps.apple.com/${country}/app/CalendarTask/id1570563588`;
        this.setState({iOSUrl:iOSUrl});
    }

    //判断是否是微信浏览器的函数
    isWeiXin() {
        //window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
        var ua = navigator.userAgent.toLowerCase();
        //通过正则表达式匹配ua中是否含有MicroMessenger字符串
        if (ua.match(/MicroMessenger/i) === 'micromessenger') {
            return true;
        } else {
            return false;
        }
    }

    onClickDownload() {

    }

    render() {

        var isChs = false;
        let locale = Locale.Instance.getLocal();
        if ( locale === 'zh') {
            isChs = true
        }

        return (

            <div className="homepage-container" >
                <img style={{ display: this.state.isWechatWeb }} src={wechat_open_web} alt="wechat open web" className="wechat-modal" />

                <img src={homepage_logo} alt="homepage logo" className="homepage-logo" />
                <div className="homepage-slogn"><FormattedMessage id='homepage_slogn' /></div>
                <div className="homepage-feature mt-8"><FormattedMessage id='feature_no_ad' /></div>
                <div className="homepage-feature mt-4"><FormattedMessage id='feature_easy' /></div>
                <div className="homepage-feature mt-4"><FormattedMessage id='feature_reminder' /></div>
                <div className="homepage-feature mt-4"><FormattedMessage id='feature_countdown' /></div>

                {this.state.iOSWeb ?
                    <a href={this.state.iOSUrl}  className="homepage-dl-android-btn" >
                        <img src={dl_apple_icon} className="dl_icon"></img>
                        <FormattedMessage id='homepage_download' />
                    </a>
                    :
                    <div>
                    { isChs ?
                        <a href="https://a.app.qq.com/o/simple.jsp?pkgname=com.xdiarys.www" download="desktopcal_android.apk" className="homepage-dl-android-btn" >
                            <img src={dl_android_icon} className="dl_icon"></img>
                            <FormattedMessage id='homepage_download' />
                        </a>
                        :
                        <a href="https://play.google.com/store/apps/details?id=com.xdiarys.www" download="desktopcal_android.apk" className="homepage-dl-android-btn" >
                            <img src={dl_android_icon} className="dl_icon"></img>
                            <FormattedMessage id='homepage_download' />
                        </a>
                    }
                    </div>
                }

            </div>
        )
    }
}




export default injectIntl(HomePage);
